import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  viewChild,
  viewChildren
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import { ContentDirective } from '@amfam/shared/utility/shared-services/lib/copy/content.directive';

import { NotificationObj } from '../../../models/notification-model';
import { HeaderWrapperService } from '../../../services/header-wrapper.service';

@Component({
  selector: 'ds-header-mobile-notification',
  templateUrl: './ds-header-mobile-notification.component.html',
  // TODO: @jjc - Consolidate these
  styleUrls: [
    './ds-header-mobile-notification.component.scss',
    '../shared/ds-header-mobile-navigation.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentDirective]
})
export class DsHeaderMobileNotificationComponent {
  private headerWrapperService = inject(HeaderWrapperService);
  private featureFlagService = inject(FeatureFlagService);
  private router = inject(Router);

  readonly notifications = input<NotificationObj[] | null>();
  readonly experienceId = input<string>();
  readonly notificationItems = viewChildren<ElementRef>('notificationItem');
  readonly notificationMenuLink = viewChild<ElementRef>('notificationMenuLink');

  readonly notificationMessage = 'You have no notifications';
  readonly showNotificationMenuSub = toSignal(
    this.headerWrapperService.mobileNotificationMenuOpen$,
    { initialValue: false }
  );
  private readonly showMenu = toSignal(this.headerWrapperService.mobileMenuOpen$, {
    initialValue: false
  });
  readonly notificationMenu = computed(() => {
    const notifications = this.notifications();
    return notifications
      ? this.headerWrapperService.buildNotificationMessageArray(notifications, this.experienceId())
      : undefined;
  });

  toggleSub() {
    this.headerWrapperService.setMobileNotificationMenuOpen(!this.showNotificationMenuSub());
    if (this.showMenu()) {
      this.headerWrapperService.setMobileMenuOpen(false);
    }
  }

  onLinkBlur(target: unknown) {
    if ((target as Node | null)?.parentNode === this.notificationItems().at(-1)?.nativeElement) {
      this.notificationMenuLink()?.nativeElement.focus();
    }
  }

  onLinkClick(message: NotificationObj) {
    if (this.featureFlagService.isEnabled('policy_new_template')) {
      this.router.navigate([message.linkRoute], {
        queryParams: { scrollTo: 'documentsCard' }
      });
    } else {
      this.router.navigate([message.linkRoute], {
        queryParams: { openAccordion: 'documents', tid: 'newdocnotice' }
      });
    }
    this.headerWrapperService.setMobileNotificationMenuOpen(false);
  }

  onDismissClick(notification: NotificationObj) {
    this.headerWrapperService.setMobileNotificationMenuOpen(false);
    this.headerWrapperService.setNotificationToDismiss(notification);
  }
}
